import script from "./AccountDetailsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountDetailsPanel.vue?vue&type=script&setup=true&lang=js"

import "./AccountDetailsPanel.vue?vue&type=style&index=0&id=78906fbd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78906fbd"]])

export default __exports__